import { render, staticRenderFns } from "./dui-slim-progress-bar.vue?vue&type=template&id=5d2b11a2&scoped=true&"
import script from "./dui-slim-progress-bar.vue?vue&type=script&lang=js&"
export * from "./dui-slim-progress-bar.vue?vue&type=script&lang=js&"
import style0 from "./dui-slim-progress-bar.vue?vue&type=style&index=0&id=5d2b11a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2b11a2",
  null
  
)

export default component.exports